module.exports = __webpack_public_path__ + "img/Small-Bevel-Attachment-28.7486f949.png";